import logger from '../utils/logger';
import api from '../config/api';

export const baristaService = {
    async createBarista(baristaData) {
        try {
            const response = await api.post('/auth/create-barista', baristaData);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to create barista:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to create barista' };
        }
    },

    async getShopBaristas() {
        try {
            const response = await api.get('/shop/baristas');
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to fetch baristas:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch baristas' };
        }
    },

    async updateBarista(baristaId, baristaData) {
        try {
            const response = await api.put(`/shop/baristas/${baristaId}`, baristaData);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to update barista:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to update barista' };
        }
    },

    async deleteBarista(baristaId) {
        try {
            await api.delete(`/shop/baristas/${baristaId}`);
            return { success: true };
        } catch (error) {
            logger.error('Failed to delete barista:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to delete barista' };
        }
    },

    async toggleBaristaStatus(baristaId) {
        try {
            const response = await api.put(`/shop/baristas/${baristaId}/toggle-status`);
            return { success: true, data: response.data };
        } catch (error) {
            logger.error('Failed to toggle barista status:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to toggle barista status' };
        }
    }
};

export default baristaService; 